<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputBuilding" });
import { InputText } from "../../../../inputs/index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
</script>

<InputText
    bind:value
    placeholder = 'resource.address.properties.building.placeholder'
    label = 'resource.address.properties.building.label'
    name = 'address.building'
    { isDisabled }
    { isReadonly }
    { isRequired }
/>